import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IOrderTag } from '../interfaces/order-tag';
import { IOrderTagFilter } from '../interfaces/order-tag-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class OrderTagService extends EditService<IOrderTag, IOrderTagFilter> {
  url = '/api/ordertags';
  entityTitle = 'Tag';

  checkDescEndpoint = `${this.url}/checkdesc`;

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  create(JobTag: IOrderTag): Promise<any> {
    console.log('JobTag');
    console.log(JobTag.id);
    let successMsg =
      typeof JobTag.id != 'undefined' && JobTag.id != 0 ? 'Tag updated.' : 'Tag added.';

    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    return this.handleRequest(
      this.http.post(this.url + '/save', JobTag, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }

  getForCustomer(customerId: number): Promise<any> {
    return this.handleRequest(
      this.http.get<IOrderTag[]>(`${this.url}/for-customer/${customerId}`),
      this.handlersFactory.getForReadAll(),
    );
  }

  getAll(): Promise<IOrderTag[]> {
    return this.handleRequest<IOrderTag[]>(
      this.http.get<IOrderTag[]>(`${this.url}/getAll`),
      this.handlersFactory.getForReadAll(),
    );
  }
}
